import {createRouter, createWebHistory} from 'vue-router';
import { getAppBase } from '@/commons/utils/urlUtil';
import auth from '@/commons/authService';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import routerPage from './routerPage';
import routerDemo from './routerDemo';
import routerDashboard from './routerDashboard';
import routerDI from './routerDI';
import routerTreasury from './routerTreasury';
import routerReport from './routerReport';
import routerKnowledge from './routerKnowledge';
import routerCash from './routerCash';
import routerEtreasury from './routerEtreasury';
import routerDeposits from './routerDeposits';
import routerInventory from './routerInventory';
import routerTools from './routerTools';
import routerAsset from './routerAsset';
import routerSalary from './routerSalary';
import routerPurchase from './routerPurchase';
import routerSell from './routerSell';
import routerInvoice from './routerInvoice';
import routerTax from './routerTax';
import routerSummary from './routerSummary';
import routerAssetQLTS from './routerAssetQLTS';
import routerOpening from './routerOpening';
import routerUtil from './routerUtil';
import routerCompanyInfo from './routerCompanyInfo';
import routerConnect from './routerConnect';
import routerAccountBalance from './routerAccountBalance';
import routerChoseFinanceReportSetting from './routerChoseFinanceReportSetting';
// import routerConvert from './routerConvert';
import routerAccessHistory from './routerAccessHistory';
import routerMagementUser from './routerMagementUser';
import routerRole from './routerRole';
import routerInitialInformationDeclaration from './routerInitialInformationDeclaration';
import routerOpeningSupplyEntry from './routerOpeningSupplyEntry';
import applicationVersion from '@/apis/proxy/versionApplicationApi.js';
import routerConnectASP from './routerConnectASP';
import { showError } from '@/commons/globalMessage';
import mplPlatformAPI from '@/apis/proxy/mplPlatformAPI.js';
import store from '@/stores/store';
import { ModuleContext } from '@/stores/moduleConst';
// import { useBackupCommon } from '@/views/utility/backup/BackupCommon';

const routes = [
  {
    path: '',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: {
      // anonymous: true
    },
    children: [
      //default home
      {
        path: '',
        redirect: localStorage.getItem('mimosa_current_path')
          ? localStorage.getItem('mimosa_current_path')
          : window._defaultConfig?.pathDefault ?? '/initialinformationdeclaration',
        meta: {},
      },
      ...routerTreasury,
      ...routerDemo,
      ...routerDashboard,
      ...routerDI,
      ...routerReport,
      ...routerKnowledge,
      ...routerCash,
      ...routerEtreasury,
      ...routerDeposits,
      ...routerInventory,
      ...routerTools,
      ...routerAsset,
      ...routerSalary,
      ...routerPurchase,
      ...routerSell,
      ...routerInvoice,
      ...routerTax,
      ...routerSummary,
      ...routerAssetQLTS,
      ...routerOpening,
      ...routerUtil,
      ...routerConnect,
      ...routerAccountBalance,
      ...routerChoseFinanceReportSetting,
      ...routerCompanyInfo,
      // ...routerConvert,
      ...routerAccessHistory,
      ...routerMagementUser,
      ...routerRole,
      ...routerInitialInformationDeclaration,
      ...routerOpeningSupplyEntry,
      ...routerConnectASP,
    ],
  },
  ...routerPage,
  {
    // Redirect to 404 page, if no match found
    path: '/:pathMatch(.*)*',
    component: () => import(/*webpackChunkName:'pages'*/ '@/pages/404.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/invoice/saleInvoicePrintPreview',
    name: 'previewInvoice',
    component: () =>
      import(
        /*webpackChunkName:'invoice'*/
        '@/views/invoice/saleInvoicePrintPreview/StaticSaleInvoicePrintPreview.vue'
      ),
    meta: {},
  },
  {
    path: '/invoice/receiptPrintView',
    name: 'previewReceipt',
    component: () =>
      import(
        /*webpackChunkName:'invoice'*/
        '@/views/invoice/receipt/ReceiptPrintPreview.vue'
      ),
    meta: {},
  },
];

// let routerOnReady = function () {};

// let routerOnError = function () {
//   // commonFunc.errorLogging(error);
// };

const router = createRouter({
  history: createWebHistory(getAppBase() || undefined),
  routes,
});

// router.onError((error) => {
//   const pattern = /Loading chunk (\S)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   if (isChunkLoadFailed && window._appConfig.showLoadChunkFail) {
//     messageBox.showError(i18n.t("i18nSY.LoadChuckFail")).then(() => {
//       window.location.reload();
//     });
//   }
// });

// router.onReady(routerOnReady, routerOnError);

router.afterEach(() => {
  commonFn.unmask();
});

router.beforeEach(async (toRouter, from, next) => {
  //Log kiểm tra phiên bản ui
  applicationVersion.logVersionAsync().then();
  //khi chuyển router sẽ show maskloading cho người dùng biết xử lý
  //do tình huông tải file js chậm
  //trong after sẽ ẩn mask loading đi
  //Tạm thời dùng loading global, sau này có thể làm kiểu thanh line chạy ngay dưới address bar sau
  commonFn.mask();
  window._cacheTitlePage = [];

  // HMDDUC2 28.04.2025:TH xem tổng quan từ TT24 sau đó đổi về TT107 thì đá về dashboard do TT107 không router này
  if(toRouter && toRouter.path.includes("/overview")){
    next("/dashboard");
    return;
  }

  //hide all popup
  //TODO => Ẩn tất cả popup ở đây
  popupUtil.hideAll();
  //trang không authen
  if (toRouter.meta.anonymous) {
    next();
    return;
  }
  console.log(toRouter.path);
  
  // Biến check xem refresh token có thành công không
  let isRefreshTokenSuccess = true;

  // kiểm tra authen -> refresh token
  if (!auth.isAuthenticated()) {
    // Thực hiện refresh token
    isRefreshTokenSuccess = await auth.refreshToken();
  }

  // Nếu hết hạn refresh token thì thực hiện đăng xuất
  if (!isRefreshTokenSuccess) {
    // MPL (MISA Platform): nếu refresh token thất bại nhưng phiên MPL vẫn còn sống,
    // re-trigger signin callback thay vì logoff hẳn (phiên MPL độc lập với JWT của Mimosa)
    if (window.isCheckMisaPlatform) {
      try {
        const stillMplSession = await mplPlatformAPI.checkMplSessionStatus();
        if (stillMplSession) {
          window.location.href = window.location.origin + window._apis.Proxy + '/mpl/accounting';
          return;
        }
      } catch (ex) {
        console.log(ex);
      }
    }
    commonFn.unmask();
    showError('Phiên làm việc đã kết thúc.').then(() => {
      commonFn.logoff();
    });
    return;
  }

  // MPL (MISA Platform): phát hiện đã chuyển đơn vị trên MPL Launcher (thay đổi cookie x-platform-version/x-subtenant-id)
  if (window.isCheckMisaPlatform && commonFn.getCookie('x-platform-version') === '2') {
    const cookieSubTenantId = commonFn.getCookie('x-subtenant-id');
    const contextSubTenantId = store.state[ModuleContext]?.Context?.MPLSubTenantId;

    // Case A: có x-subtenant-id (user thuộc sub-tenant/phòng ban) → so sánh trực tiếp
    if (cookieSubTenantId && cookieSubTenantId !== contextSubTenantId) {
      window.location.href = window.location.origin + window._apis.Proxy + '/mpl/accounting';
      return;
    }

    // Case B: không có x-subtenant-id (root tenant) → x-tenantid là HttpOnly, gọi BE để lấy
    if (!cookieSubTenantId) {
      const contextMplTenantId = store.state[ModuleContext]?.Context?.MPLTenantId;
      if (contextMplTenantId) {
        try {
          const tenantContext = await mplPlatformAPI.getTenantContext();
          if (tenantContext.TenantId !== contextMplTenantId) {
            window.location.href = window.location.origin + window._apis.Proxy + '/mpl/accounting';
            return;
          }
        } catch (ex) {
          console.log(ex);
        }
      }
    }
  }

  commonFn.checkHasDatabaseID(toRouter);
  commonFn.checkPermissionDVC(toRouter);
  commonFn.checkHideNotificationWarningDate(toRouter);
  try {
    let checkRouter = await commonFn.checkPermissionRouter(toRouter);
    if (!checkRouter) {
      next('/report');
      return;
    }
  } catch (error) {
    commonFn.unmask();
  }
  

  let isPermission = false;
  // tvhien 26.12.2022
  //tạo object để có thể thay đổi giá trị isPermission khi truyền vào function
  const isPermissionObject = {
    isPermission: isPermission,
  };

  commonFn.checkPermissionByRoute(isPermissionObject, toRouter);

  //default
  next();
});

export default router;
